import React from "react";
import { FaBoxOpen } from "react-icons/fa";
import { getShippingDisplayLines, hasShippingDetails } from "../utils/orderAddress";
import { resolveAssetUrl } from "../utils/assets";
import "./OrderDetailsPanel.css";

const OrderDetailsPanel = ({ order, showItems = true }) => {
  if (!order) return null;

  const shippingLines = getShippingDisplayLines(order.shippingAddress);
  const items = order.items || [];

  return (
    <div className="order-details-panel">
      {hasShippingDetails(order.shippingAddress) ? (
        <div className="order-details-block">
          <h4>Delivery details</h4>
          <dl className="order-details-dl">
            {shippingLines.map(({ label, value }) => (
              <div key={label} className="order-details-row">
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      ) : (
        <p className="order-details-empty">No delivery details recorded for this order.</p>
      )}

      {showItems && items.length > 0 && (
        <div className="order-details-block">
          <h4>Items ({items.length})</h4>
          <ul className="order-details-items">
            {items.map((item, index) => {
              const image = resolveAssetUrl(item.image || "");
              return (
                <li key={item._id || `${item.name}-${index}`}>
                  <div className="order-details-item-main">
                    <div className="order-details-thumb">
                      {image ? (
                        <img src={image} alt="" loading="lazy" decoding="async" />
                      ) : (
                        <FaBoxOpen />
                      )}
                    </div>
                    <div className="order-details-item-meta">
                      <span className="order-details-item-name">{item.name}</span>
                      <span className="order-details-item-qty">
                        Qty {item.quantity} · AED {Number(item.price || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  <strong>
                    AED {(Number(item.price) * item.quantity).toFixed(2)}
                  </strong>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {order.notes ? (
        <div className="order-details-block">
          <h4>Order notes</h4>
          <p className="order-details-notes">{order.notes}</p>
        </div>
      ) : null}
    </div>
  );
};

export default OrderDetailsPanel;
